package com.wintermar.inspection.core.ui.theme.color.model

import androidx.compose.ui.graphics.Color

data class ColorVariant(
    val n25: Color = Color.Unspecified,
    val n50: Color = Color.Unspecified,
    val n100: Color,
    val n200: Color,
    val n300: Color,
    val n400: Color,
    val n500: Color,
    val n600: Color,
    val n700: Color,
    val n800: Color,
    val n900: Color,
    val n1000: Color = Color.Unspecified
)
